'use client';

import { usePathname, useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { ROUTES } from '../../../constants/routes';
import {
  isAuthenticatedSession,
  useAuthSession,
} from '../hooks/useAuthSession';

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { data: session, isLoading } = useAuthSession();
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    if (isLoading) return;
    if (!isAuthenticatedSession(session)) {
      const params = new URLSearchParams();
      if (pathname && pathname !== ROUTES.auth) {
        params.set('from', pathname);
      }
      const q = params.toString();
      router.replace(q ? `${ROUTES.auth}?${q}` : ROUTES.auth);
    }
  }, [isLoading, session, pathname, router]);

  if (isLoading) {
    return (
      <div className='flex min-h-[40vh] items-center justify-center text-sm text-muted-foreground'>
        Checking session…
      </div>
    );
  }

  if (!isAuthenticatedSession(session)) {
    return null;
  }

  return <>{children}</>;
}
